import { io } from 'socket.io-client';

let socket = null;

/** Connect to Socket.IO for real-time notifications and messages. Call when user is logged in. */
export const getSocket = () => {
  if (!socket) {
    // Get API URL (without /api)
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    const baseURL = API_URL.replace('/api', '');
    
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    if (!token) {
      console.warn('No token found for socket connection');
      return null;
    }
    
    socket = io(baseURL, {
      auth: {
        token: token
      },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5
    });

    socket.on('connect', () => {
      console.log('Socket connected:', socket.id);
    });

    socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });
  }

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export default getSocket;
